// extracted by mini-css-extract-plugin
export default {"root":"_3P-QS","collapsed":"_33akC"};